import React, { useCallback, useEffect, useState } from "react";
import { AiOutlineDelete } from "react-icons/ai";
import { LuPencilLine } from "react-icons/lu";
import { useDispatch, useSelector } from "react-redux";
import {
  addSubTopic,
  deleteSubTopic,
  editSubTopic,
  getAllSubTopic,
  getSingleSubTopic,
} from "../../redux/services/subTopicSlice";
import { toast } from "react-toastify";
import SubTopicForm from "./subTopicForm";
import * as Yup from "yup";
import { useFormik } from "formik";
import ConfirmationPage from "../../common/ConfirmationPage";
import Table from "../../common/Table";

const SubTopic = () => {
  const dispatch = useDispatch();
  const getAllSubTopicData = useSelector(
    (state) => state.subTopic.subTopicData
  );
  const getSingleSubTopicData = useSelector(
    (state) => state?.subTopic?.singleSubTopicData
  );
  const [modelOpen, setModelOpen] = useState(false);
  const [editId, setEditId] = useState();
  const [itemToDelete, setItemToDelete] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");
  const [confirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const limitOptions = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);
  const initialValues = {
    name: "",
  };
  const validationSchema = Yup.object({
    name: Yup.string().required("Contest Type  is required"),
  });
  const getAllSubTopicApi = useCallback(async () => {
    try {
      await dispatch(
        getAllSubTopic({ page: page + 1, limit: pageLimit, searchData })
      );
    } catch (error) {}
  }, [dispatch, page, pageLimit, searchData]);

  useEffect(() => {
    getAllSubTopicApi();
  }, [getAllSubTopicApi]);

  const onSubmit = async () => {
    setLoading(true);
    const payload = { ...values };

    if (editId) {
      payload.subTopicId = editId;
    }
    try {
      let response;
      if (editId) {
        response = await dispatch(editSubTopic(payload));
      } else {
        response = await dispatch(addSubTopic(payload));
      }
      if (response?.payload?.status === 200) {
        toast.success(response?.payload?.message, {
          autoClose: 2000,
          pauseOnHover: false,
        });
        setLoading(false);
        setModelOpen(false);
        resetForm();
        getAllSubTopicApi();
      } else {
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    setValues,
    resetForm,
  } = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  const deleteSubTopicData = async () => {
    try {
      const response = await dispatch(deleteSubTopic(itemToDelete));
      toast.success(response?.payload?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setConfirm(false);
      getAllSubTopicApi();
    } catch (error) {}
  };
  const getSingleSubTopicApi = useCallback(async () => {
    try {
      await dispatch(getSingleSubTopic(editId));
    } catch (error) {}
  }, [dispatch, editId]);

  useEffect(() => {
    if (editId) {
      getSingleSubTopicApi();
    }
  }, [editId, getSingleSubTopicApi]);
  useEffect(() => {
    if (getSingleSubTopicData) {
      setValues({
        name: getSingleSubTopicData.name,
      });
    }
  }, [getSingleSubTopicData, setValues]);
  const columns = [
    {
      header: "S/N",
      key: "index",
      render: (_, __, index) => page * pageLimit + index + 1,
    },
    {
      header: "Sub Topics",
      key: "name",
    },
  ];
  const actions = [
    {
      icon: <LuPencilLine className="w-5 h-5" />,
      onClick: (row) => {
        setModelOpen(true);
        setEditId(row._id);
      },
    },
    {
      icon: <AiOutlineDelete className="w-6 h-6" />,
      onClick: (row) => {
        setItemToDelete(row._id);
        setConfirm(true);
      },
    },
  ];
  return (
    <div>
      <Table
        title="Sub-Topic"
        buttonTitle="Add New Sub-Topic"
        showSearchbar={true}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        setSearchData={setSearchData}
        onAddClick={() => setModelOpen(true)}
        columns={columns}
        data={getAllSubTopicData?.sub_topic_data || []}
        actions={actions}
        pageCount={getAllSubTopicData?.state?.page_limit}
        onPageChange={(selectedItem) => setPage(selectedItem.selected)}
        pageLimitOptions={limitOptions}
        selectedPageLimit={pageLimit}
        onPageLimitChange={setPageLimit}
      />

      {confirm && (
        <ConfirmationPage
          topicName="Sub Topic"
          confirm={confirm}
          onDelete={deleteSubTopicData}
          onCancel={() => setConfirm(false)}
        />
      )}
      {modelOpen && (
        <SubTopicForm
          modelOpen={modelOpen}
          setModelOpen={setModelOpen}
          onClose={() => {
            setModelOpen(false);
            resetForm();
            setEditId();
          }}
          values={values}
          editId={editId}
          handleChange={handleChange}
          handleBlur={handleBlur}
          errors={errors}
          touched={touched}
          handleSubmit={handleSubmit}
          loading={loading}
        />
      )}
    </div>
  );
};

export default SubTopic;
